import { NOTIFICATION_FREQUENCY } from "@/static/notificationFrequency";
import { NOTIFICATION_TRIGGER } from "@/static/notificationTrigger";
import { Expose } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsString } from "class-validator";

export class EditBookingNotificationConfiguration {
  @Expose()
  @IsNumber()
  mailConfigurationId!: number;
  @Expose()
  @IsEnum(NOTIFICATION_FREQUENCY)
  notificationFrequency!: number;
  @Expose()
  @IsEnum(NOTIFICATION_TRIGGER)
  notificationTrigger!: number;
  @Expose()
  @IsString()
  scheduledTime!: string;
  @Expose()
  @IsBoolean()
  isActive!: boolean;
}
export class BookingNotificationConfiguration extends EditBookingNotificationConfiguration {
  @Expose()
  @IsNumber()
  recordStampId!: number;
}
